// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__BLEWz","itemTitle":"ClientEmergencyInfo_itemTitle__3BQdH","itemText":"ClientEmergencyInfo_itemText__M2QBa"};